import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Parcel } from 'src/app/_models/parcel';

@Component({
  selector: 'app-bookings-district',
  templateUrl: './bookings-district.component.html',
  styleUrls: ['./bookings-district.component.scss']
})
export class BookingsDistrictComponent implements OnInit {

  constructor(public router: Router) { }

  ngOnInit() {
  }

  navigateTo(value: string) {
    console.log(value)
    this.router.navigate(['/contact/appointment/' + value]);
  }

  getAddress(item: Parcel) {
    console.log(item)
    let office = item.DistrictOffice.toLocaleLowerCase();

    if(office.includes('north'))
      this.navigateTo('LACAssessorNorthDistrict');
    else if(office.includes('east'))
      this.navigateTo('LACAssessorEastDistrict');
    else if(office.includes('west'))
      this.navigateTo('LACAssessorWestDistrict');
    else if(office.includes('south'))
     this.navigateTo('LACAssessorSouthDistrict');
    else if(office.includes('lancaster'))
     this.navigateTo('LACAssessorLancasterDistrict');
  }

}
